import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import loader from '../../assets/loader.svg';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ScrollArea from 'react-scrollbar';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Agreement from './Agreement';
import NewAgreement from './NewAgreement';
import PlanModal from '../UserPlan/PlanModal';
import emptyTray from '../../assets/emptytray.svg';
import { selectAgreementsState } from '../../redux/selectors';
import { getSubscriptionType } from '../../utils';

class AgreementList extends Component {
  constructor() {
    super();
    this.state = {
      finalized_deals: [],
      loading: 'init',
      planModalOpen: false,
      isPremiumExpired: false,
      agreementType: 0,
    };
    this.renderEmptyAgreementList = this.renderEmptyAgreementList.bind(this);
  }

  componentWillMount() {
    const { profile } = this.props;

    if (profile && profile.id) {
      this.props.loadFinalizedDeals(profile.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { profile, status, finalizedDeals } = nextProps;

    if (profile && profile.id !== this.props.profile.id) {
      this.props.loadFinalizedDeals(profile.id);
    }

    if (this.props.status !== status) {
      if (
        status === actionTypes.FINALIZED_DEALS_GET_REQUEST &&
        finalizedDeals.length === 0
      ) {
        this.setState({ loading: 'loading' });
      }
      if (
        status === actionTypes.FINALIZED_DEALS_GET_SUCCESS ||
        status === actionTypes.FINALIZED_DEALS_GET_ERROR
      ) {
        this.setState({ loading: 'loaded' });
      }
    }
  }

  getFinalizedDeals() {
    let { finalizedDeals, type, searchText, fields } = this.props;
    const agreements = [];

    if (finalizedDeals && finalizedDeals.length > 0) {
      finalizedDeals = _.filter(finalizedDeals, (deal) =>
        deal.agreement_info.name
          .toLowerCase()
          .includes(searchText.toLowerCase())
      );
      finalizedDeals = _.orderBy(
        finalizedDeals,
        [(deal) => deal.agreement_info.name],
        ['asc']
      );
      finalizedDeals = _.orderBy(
        finalizedDeals,
        [(deal) => deal.date_created],
        ['desc']
      );
    }

    if (finalizedDeals && finalizedDeals.length > 0) {
      if (type === 'create') {
        finalizedDeals = _.filter(
          finalizedDeals,
          (deal) =>
            deal.agreement_info.type !== 'workforhire' &&
            deal.agreement_info.type !== 'producer'
        );

        if (parseInt(fields.subtype, 10) === 1) {
          // "Sound Recording"
          finalizedDeals = _.filter(
            finalizedDeals,
            (deal) => parseInt(deal.work_info.sub_type, 10) === 1
          );
        } else {
          finalizedDeals = _.filter(
            finalizedDeals,
            (deal) => parseInt(deal.work_info.sub_type, 10) !== 1
          );
        }
      }

      return finalizedDeals.map((deal) => {
        if (agreements.indexOf(deal.agreement) === -1) {
          agreements.push(deal.agreement);
          return (
            <Agreement
              key={deal.agreement_info.id + '' + deal.id}
              source={type}
              agreement={deal.agreement_info}
              handleClick={() => this.agreementSelect(deal.agreement_info)}
            />
          );
        } else {
          return null;
        }
      });
    } else if (this.state.loading === 'loaded') {
      if (type === 'create') {
        return (
          <h4 className="text-center agreement-header">
            You Have No Eligible Finalized Agreements :(
          </h4>
        );
      } else {
        return null;
      }
    }
  }

  agreementSelect(agreement) {
    const { profile, subscription } = this.props;

    this.props.selectAgreement(agreement);

    if (this.props.type === 'view' || this.props.type === 'dashboard') {
      this.props.deselectTeam();
      this.props.router.push(`/agreements/${agreement.id}/detail`);
    } else {
      const { planType } = getSubscriptionType(
        profile.subscription_plan,
        subscription
      );
      const isPremiumExpired =
        profile.subscription_plan === 'premium' &&
        profile.trial_expired === true;

      if (isPremiumExpired || planType === 'free') {
        if (agreement.type === 'split') {
          this.props.router.push(`/create/agreement-detail`);
        } else {
          // Show upgrade modal for premium splits agreement
          this.setState({
            planModalOpen: true,
            isPremiumExpired: isPremiumExpired,
            agreementType: 1,
          });
        }
      } else {
        this.props.router.push(`/create/agreement-detail`);
      }
    }
  }

  hidePlanModal = (type) => {
    this.setState({ planModalOpen: false, agreementType: 0 }, () => {
      if (type) {
        this.props.router.push(`/create/agreement-detail`);
      }
    });
  };

  renderEmptyAgreementList() {
    return (
      <div className="empty-agreements">
        {this.props.type !== 'create' ? (
          <div>
            <img src={emptyTray} className="bottom-push" alt="empty contents" />
            <div className="title">
              You don’t have any pending agreements or deals!
            </div>
            <div className="title bottom-push">
              Why don't you <Link to={'/create'}>create one?</Link>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const { subscription, profile } = this.props;
    const { planModalOpen, isPremiumExpired, agreementType } = this.state;

    return (
      <div className="agreements">
        {this.props.type === 'create' ? (
          <Row>
            <Col sm={6}>
              <h1 className="new-ag-title1 text-center">
                Start a new agreement
              </h1>
              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-split">
                    <div className="tootip-text">
                      The easiest and simplest way to establish copyright
                      ownership.
                      <br />
                      Lists all of the co-owners of the content and their
                      ownership shares, publisher information, and performing
                      rights societies (if applicable).
                    </div>
                  </Tooltip>
                }
                placement="right"
              >
                <div className="agreement-defs">
                  <NewAgreement
                    type={this.props.type}
                    workSubType={this.props.fields.subtype}
                    title="Split Sheet"
                    agreementType={0}
                  />
                </div>
              </OverlayTrigger>

              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-split">
                    <div className="tootip-text">
                      Establish greater control over copyright ownership and how
                      the content can be used.
                      <br />
                      Outlines important details about the content such as which
                      collaborators are permitted to license it on your behalf,
                      branding permissions, dispute resolution, how
                      payments/royalties should be managed, and more.
                    </div>
                  </Tooltip>
                }
                placement="right"
              >
                <div className="agreement-defs">
                  <NewAgreement
                    type={this.props.type}
                    workSubType={this.props.fields.subtype}
                    title="Collaboration Agreement"
                    agreementType={1}
                  />
                </div>
              </OverlayTrigger>

              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-split">
                    <div className="tootip-text">
                      Establishes copyright ownership whenever hiring others to
                      help. Providing payment may not be enough to prevent
                      someone from having a claim of copyright ownership.
                      <br />A work for hire agreement outlines the scope and
                      terms of the work to be completed and prevents false
                      claims of ownership from third parties.
                    </div>
                  </Tooltip>
                }
                placement="right"
              >
                <div className="agreement-defs">
                  <NewAgreement
                    type={this.props.type}
                    workSubType={this.props.fields.subtype}
                    title="Work for Hire Agreement"
                    agreementType={2}
                  />
                </div>
              </OverlayTrigger>

              {this.props.fields.type === 2 && ( // only Music
                <OverlayTrigger
                  overlay={
                    <Tooltip id="tooltip-split">
                      <div className="tootip-text">
                        Establishes ownership of the masters whenever hiring a
                        producer to create music.
                        <br />
                        Outlines significant details about how the music will be
                        produced, how the producer will be credited, how
                        disputes should be handled, how payments/royalties
                        should be managed, and more.
                      </div>
                    </Tooltip>
                  }
                  placement="right"
                >
                  <div className="agreement-defs">
                    <NewAgreement
                      type={this.props.type}
                      workSubType={this.props.fields.subtype}
                      title="Producer Agreement"
                      agreementType={3}
                    />
                  </div>
                </OverlayTrigger>
              )}
              <br />
            </Col>
            <Col sm={6}>
              {this.state.loading === 'loading' && (
                <div className="loader">
                  <img src={loader} alt="Loading spinner" />
                </div>
              )}
              {this.props.finalizedDeals.length > 0 && (
                <h1 className="blue-title">
                  Add work(s) to an existing agreement
                </h1>
              )}

              {this.getFinalizedDeals()}

              <br />
            </Col>
          </Row>
        ) : (
          <div className="completed-agreements">
            {this.props.finalizedDeals.length > 0 && (
              <h4 className="agreement-header">Finalized Agreements</h4>
            )}
            {this.state.loading === 'loading' && (
              <div className="loader">
                <img src={loader} alt="Loading spinner" />
              </div>
            )}
            <ScrollArea
              className="agreement-wrapper"
              horizontal={false}
              verticalContainerStyle={{ background: 'transparent' }}
              verticalScrollbarStyle={{ background: '#11a7d8' }}
              smoothScrolling
              stopScrollPropagation
            >
              {this.getFinalizedDeals()}
            </ScrollArea>
          </div>
        )}

        <PlanModal
          show={planModalOpen}
          subscriptionPlan={profile.subscription_plan}
          referrer={profile.referrer}
          // showCheckoutStep={isPremiumExpired}
          isPremiumExpired={isPremiumExpired}
          showAllPlan={isPremiumExpired}
          agreementType={agreementType}
          isCanceledSubscription={
            subscription &&
            subscription.status === 'Canceled' &&
            profile.subscription_plan === 'free'
          }
          hidePlanModal={this.hidePlanModal}
        />
      </div>
    );
  }
}

AgreementList.defaultProps = {
  searchText: '',
};

AgreementList.propTypes = {
  searchText: PropTypes.string,
};

const mapStateToProps = (state, props) => ({
  team: state.teams.selectedTeam,
  profile: state.profile,
  finalizedDeals: selectAgreementsState(state, props),
  status: state.deals.status,
  fields: state.create.fields,
  subscription: state.payment.subscription,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  deselectTeam: () => {
    dispatch(actions.selectTeam(null));
  },
  selectAgreement: (agreement) => {
    dispatch(actions.selectAgreement(agreement));
  },
  loadFinalizedDeals: (id) => {
    dispatch(actions.getFinalizedDeals(id));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AgreementList));



// WEBPACK FOOTER //
// src/components/Agreements/AgreementList.jsx